'use strict';
const angular = require('angular');

export class suiteEntityDatatableComponent {
  constructor(SettingsService, IntegrationService, DTOptionsBuilder, $timeout) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.IntegrationService = IntegrationService;
    this.DTOptionsBuilder = DTOptionsBuilder;
    this.$timeout = $timeout;
  }

  $onInit() {

    var tableName = this.name;

    this.SettingsService.getByName({name: "datatable-custom-column-sortorder"}, sortorders => {
      if (sortorders && sortorders.data) {

        sortorders.data.forEach(sortorder => {

          var generateSortorderFunction = function(sortorder) {
            return function (x, y) {
              var Rank = function(rank, pattern) {
                this.rank = rank;
                this.pattern = pattern;
                return {
                  rank: this.rank,
                  pattern: this.pattern,
                  getLengthPrefix: function() {
                    var p = this.pattern.split(".");
                    return p[0].length;
                  }
                }
              };

              var getPatternRank = function(value) {
                var patternCache = {};

                var pattern = sortorder;

                for (var i = 0; i<= pattern.length; i++) {

                  var rePattern = "^" + pattern[i];

                  if (!patternCache[rePattern]) {
                    patternCache[rePattern] = new RegExp("^" + pattern[i], "i");
                  }

                  if (patternCache[rePattern].test(value)) {
                    return new Rank(i, pattern[i]);
                  }

                }

                return new Rank(-1, "?");

              };

              var patRankX = getPatternRank(x);
              var patRankY = getPatternRank(y);

              if (patRankX.rank == patRankY.rank) {

                var lengthPatternX = patRankX.getLengthPrefix();
                var lengthPatternY = patRankY.getLengthPrefix();

                var valX = x.substring(lengthPatternX);
                var valY = y.substring(lengthPatternY);

                return (valX > valY) ? 1 : (valX < valY) ? -1 : 0;

              } else
                return (patRankX.rank > patRankY.rank) ? 1 : -1;

            };
          };

          jQuery.fn.dataTableExt.oSort[sortorder.name + "-asc"] = generateSortorderFunction(sortorder.data);

          jQuery.fn.dataTableExt.oSort[sortorder.name + "-desc"] = function (x, y) {
            return jQuery.fn.dataTableExt.oSort[sortorder.name + "-asc"](y, x);
          };

        });

      }
    });

    this.SettingsService.getByName({name: this.settings}, setting => {

      this.IntegrationService.suiteQueryCustomEntityByType({type: this.entity}, data => {

        let _dtData = [];

        data.forEach(entity => {
          let _row = [];

          setting.data.fields.forEach(_ => _row.push(''));

          for (let i=0; i<setting.data.fields.length; i++) {
            _row[i] = entity.data[setting.data.fields[i]];
          }

          _dtData.push(_row);
        });

        this.dtData = _dtData;

        var delay = setting.data.delay || 350;

        this.dtSettings = setting;

        this.$timeout(function(){

          var config = {
            dom: 'lBfrtip',
            responsive: true,
            buttons: [{
              extend: 'excel',
              title: tableName
            },{
              extend: 'csv',
              title: tableName
            },{
              title: tableName,
              message: 'As of ' + moment().format("MMMM Do YYYY"),
              extend: 'pdf',
              orientation: 'portrait',
              pageSize: 'LETTER'
            },'print']
          };

          if (setting.data.columnProps) {
            config.aoColumns = setting.data.columnProps;
          }

          jQuery('table.datatable-conduu').DataTable(config);
        }, delay);
      });
    });
  }
}

export default angular.module('conduu.ap.components.suite-entity-datatable', [])
  .component('suiteEntityDatatable', {
    template: require('./suite-entity-datatable.component.html'),
    bindings: {
      entity: '@',
      settings: '@',
      name: '@'
    },
    controller: suiteEntityDatatableComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/suite-entity-datatable/suite-entity-datatable.component.js